import * as React from "react";
export const LunchBuddyIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width={56} height={56} viewBox="0 0 56 56" fill="none" {...props}>
      <defs>
        <linearGradient
          id="lunchBuddyBrandGradient"
          x1={28}
          y1={0}
          x2={28}
          y2={56}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fd5203" />
          <stop offset={1} stopColor="#fd7334" />
        </linearGradient>
      </defs>
      <rect
        width={56}
        height={56}
        rx={20}
        fill="url(#lunchBuddyBrandGradient)"
      />
      <g
        transform="translate(14 14) scale(1.16667)"
        fill="none"
        stroke="#ffffff"
        strokeWidth={2.4}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="m16 2-2.3 2.3a3 3 0 0 0 0 4.2l1.8 1.8a3 3 0 0 0 4.2 0L22 8" />
        <path d="M15 15 3.3 3.3a4.2 4.2 0 0 0 0 6l7.3 7.3c.7.7 2 .7 2.8 0L15 15Zm0 0 7 7" />
        <path d="m2.1 21.8 6.4-6.3" />
        <path d="m19 5-7 7" />
      </g>
    </svg>
  );
};
